module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Black.2e9f6612.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Black.eot
// module id = 2974
// module chunks = 70